const ByteBuffer = require("bytebuffer");

class Package {
    constructor() {
        this.clientPacketID = {
            getMyCharacter: 1,
            getCharacter: 2,
            changeRopa: 3,
            actPosition: 4,
            changeHeading: 5,
            deleteCharacter: 6,
            dialog: 7,
            console: 8,
            pong: 9,
            animFX: 10,
            inmo: 11,
            updateHP: 12,
            updateMaxHP: 13,
            updateMana: 14,
            telepMe: 15,
            actOnline: 19,
            consoleOnline: 20,
            actPositionServer: 21,
            actExp: 22,
            actMyLevel: 23,
            actGold: 24,
            actColorName: 25,
            changeHelmet: 26,
            changeWeapon: 27,
            error: 28,
            changeName: 29,
            getNpc: 30,
            changeShield: 31,
            putBodyAndHeadDead: 32,
            revivirUsuario: 33,
            quitarUserInvItem: 34,
            renderItem: 35,
            deleteItem: 36,
            agregarUserInvItem: 37,
            changeArrow: 38,
            blockMap: 39,
            changeObjIndex: 40,
            openTrade: 41,
            aprenderSpell: 42,
            closeForce: 43,
            nameMap: 44,
            changeBody: 45,
            navegando: 46,
            updateAgilidad: 47,
            updateFuerza: 48,
            playSound: 49,
            setInvisible: 50,
            npcInspect: 51,
            updateNpcHp: 52,
            npcStatus: 53,
            openBank: 54,
            bankUpdate: 55,
            // Party (TICKET party-system). Ver server/package.js para
            // detalle del wire format.
            partyState: 56,
            partyInviteReceived: 57,
            petBuff: 58,
            // Ticket #289: blip de invisibilidad. Cada ~4s mientras un
            // user está invisible, el server le manda este packet a chars
            // cercanos (no a NPCs) para que el cliente lo renderee
            // semi-visible durante X ms con fade in/out.
            invisibilityBlip: 59,
            // Ticket #313: payload completo del clan del user (modal).
            clanInfo: 60,
            // Ticket #313: posiciones live de miembros para dots en el mapa.
            clanMembersPos: 61,
            // Ticket #313 polish: lista de clanes para unirse.
            clanList: 62,
            // Ticket #321: ferry NPC — abre modal con destinos.
            openFerry: 63,
            // Lista de chars PvE conectados (panel GLOBAL del BOX 5).
            // Sin HP/pos — solo name/level/clase/raza/color.
            globalList: 64,
            // Sombra Oscura de Morgolock (#49) — state change. estado=1
            // activa el modo (char invisible + pasos mute), estado=0
            // desactiva. Sistema separado del setInvisible legacy.
            sombraOscura: 65,
            // Furia de Uhkrul (spell #50) — flag para que el cliente
            // distinga ambos attrs 38 por Furia (rojo) vs ambos 38 por
            // dos pociones independientes (marrón + verde oliva).
            // Payload: byte estado (1=activa, 0=clear).
            furiaState: 66,
            // El Ojo del Demiurgo (spell #43) — state change. Permite
            // al user ver chars invisibles con alpha 0.38.
            // Payload: int idUser, byte estado, short durationSeconds.
            ojoDemiurgo: 67,
            // Sigilo de Atidorfa (spell #51) — sigilo total.
            sigiloAtidorfa: 68,
            // Sistema /PERDON — abre modal con costo de amnistía.
            // Payload: int cost, int ciudadanosKilled.
            openPerdon: 69,
            // Morgolock's Soul — modal premium Magia. Payload: int cost.
            openMagiaUpgrade: 70,
            // Pesca (#325) — estado pescando. Payload: byte (1=on, 0=off).
            fishingState: 71,
            // Minería (#326) — estado minando. Payload: byte (1=on, 0=off).
            miningState: 72,
            // Talado (#327) — estado talando. Payload: byte (1=on, 0=off).
            talarState: 73,
            // /criminal (#328) — abre modal de confirmación. Sin payload.
            openCriminalConfirm: 74,
            // Aceleración Arcana (spell #52) — buff de velocidad de
            // movimiento 2x. Payload: byte estado (1/0) + int durationMs.
            aceleracionState: 75,
            // La Guarida del Bardo (radio comunitaria) — server manda
            // track actual. Payload: string videoId + int startedAt + string gmName.
            radioTrack: 76,
            // La Guarida del Bardo — modo Mix personalizado cuando la cola
            // se vació. Payload: string seedVideoId. Cliente carga
            // list=RD<seed> localmente; sync se pierde (cada uno oye su
            // recomendación).
            radioAutoContinue: 77,
            // userInspect — respuesta al inspect de un player. Mismo patrón
            // que npcInspect. Ver protocol.js:inspectUser para payload.
            userInspect: 78,
            // openHerreria (#329) — abre/refresca el modal de Herrería.
            // Payload: int cantHierro, int cantPlata, int cantOro (conteo
            // de minerales de cada metal que tiene el user).
            openHerreria: 79
        };

        this.serverPacketID = {
            changeHeading: 1,
            click: 2,
            useItem: 3,
            equiparItem: 4,
            connectCharacter: 5,
            position: 6,
            dialog: 7,
            ping: 8,
            attackMele: 9,
            attackRange: 10,
            attackSpell: 11,
            tirarItem: 12,
            agarrarItem: 13,
            buyItem: 14,
            sellItem: 15,
            swapItems: 16,
            changeSeguro: 17,
            updateSpellOrder: 18,
            updateFavoriteSpells: 19,
            inspectNpc: 20,
            depositItem: 21,
            withdrawItem: 22,
            swapBankSlots: 23,
            setHogarFromNpc: 24,
            // Ticket #280: pet management. despawnPet → click en buff,
            // setPetMode → right-click en buff.
            despawnPet: 25,
            setPetMode: 26,
            // Ticket #287: refresh position. Sin payload — el server
            // responde con actPositionServer + setNewAreas para resync
            // del sprite cuando se bugea visualmente.
            refreshPosition: 27,
            // Ticket #321: useFerry — confirma destino del modal marinero.
            useFerry: 28,
            // Sin payload — server responde con globalList.
            requestGlobalList: 29,
            // Click del buff icon de Sombra Oscura → desactivar.
            requestDeactivateSombraOscura: 30,
            // Generic end-buff. Payload: byte buffType (ver BUFF_TYPE
            // en engine/general.js).
            requestEndBuff: 31,
            // Click del buff icon de El Ojo del Demiurgo → server clear.
            requestDeactivateOjoDemiurgo: 32,
            // Click del buff icon de Sigilo de Atidorfa → server clear.
            requestDeactivateSigiloAtidorfa: 33,
            // Confirma pago de amnistía /PERDON. Sin payload.
            confirmPerdon: 34,
            // Confirma upgrade premium Magia. Sin payload.
            confirmMagiaUpgrade: 35,
            // Confirma el modal /criminal (#328). Sin payload.
            confirmCriminal: 36,
            // La Guarida del Bardo — cliente reporta al server que el video
            // actual terminó (state ENDED). Payload: string videoId (dedup).
            radioTrackEnded: 37,
            // inspectUser — cliente pide info de otro player. Payload:
            // int idUser (ws.id). Server responde con userInspect.
            inspectUser: 38,
            // crearLingote (#329) — cliente pide forjar un lingote en la
            // Herrería. Payload: int idLingote (386/387/388). Server valida
            // martillo + 100 minerales, consume, da 1 lingote, refresca modal.
            crearLingote: 39
        };

        this.bufferRcv = new ByteBuffer(ByteBuffer.DEFAULT_CAPACITY, true);
        this.bufferSnd = new ByteBuffer(ByteBuffer.DEFAULT_CAPACITY, true);
    }

    setData = data => {
        this.bufferRcv = new ByteBuffer.wrap(data, "utf8", true);
    };

    getPackageID = () => {
        var packageID = this.getByte();

        return packageID;
    };

    setPackageID = packageID => {
        // Pool: reusamos la misma instancia entre packets. Lado cliente
        // es seguro SIN forzar copia porque la spec del WebSocket
        // browser garantiza que `ws.send(buffer)` toma un snapshot
        // sincrónico — no retiene referencia al buffer original.
        // (Server-side es distinto: el lib `ws` de Node sí retiene
        // refs y ahí sí forzamos toBuffer(true). Ver server/package.js.)
        //
        // Beneficio: el cliente hace 10-30 sends/seg en juego activo;
        // eliminar la alloc del ByteBuffer wrapper + ArrayBuffer +
        // auto-grow es una mejora directa al frametime cada major-GC.
        this.bufferSnd.clear();
        this.writeByte(packageID);
    };

    // parseInt → (x | 0): callers pasan numbers, parseInt asume string.
    // `| 0` trunca a int32 ~10× más rápido. Bytes en wire idénticos.
    // CRÍTICO: solo en writeByte/Short/Int. NO en writeFloat/Double —
    // ver server/package.js + memoria `wire-protocol-parseint-trap`.
    writeByte = (numByte, signed) => {
        if (!numByte) {
            numByte = 0;
        }

        if (signed) {
            this.bufferSnd.writeInt8(numByte | 0);
        } else {
            this.bufferSnd.writeUint8(numByte | 0);
        }
    };

    writeShort = (numShort, signed) => {
        if (!numShort) {
            numShort = 0;
        }

        if (signed) {
            this.bufferSnd.writeInt16(numShort | 0);
        } else {
            this.bufferSnd.writeUint16(numShort | 0);
        }
    };

    writeInt = (numInt, signed) => {
        if (!numInt) {
            numInt = 0;
        }

        if (signed) {
            this.bufferSnd.writeInt32(numInt | 0);
        } else {
            this.bufferSnd.writeUint32(numInt | 0);
        }
    };

    writeFloat = numFloat => {
        if (!numFloat) {
            numFloat = 0;
        }

        this.bufferSnd.writeFloat(parseInt(numFloat));
    };

    writeDouble = numDouble => {
        if (!numDouble) {
            numDouble = 0;
        }

        this.bufferSnd.writeDouble(parseInt(numDouble));
    };

    writeString = dataString => {
        if (!dataString) {
            dataString = "";
        }

        this.writeShort(ByteBuffer.calculateUTF8Chars(dataString));

        this.bufferSnd.writeString(dataString);
    };

    getByte = signed => {
        var dByte = 0;

        if (signed) {
            dByte = this.bufferRcv.readInt8();
        } else {
            dByte = this.bufferRcv.readUint8();
        }

        return dByte;
    };

    getShort = signed => {
        var dShort = 0;

        if (signed) {
            dShort = this.bufferRcv.readInt16();
        } else {
            dShort = this.bufferRcv.readUint16();
        }

        return dShort;
    };

    getInt = signed => {
        var dInt = 0;

        if (signed) {
            dInt = this.bufferRcv.readInt32();
        } else {
            dInt = this.bufferRcv.readUint32();
        }

        return dInt;
    };

    getFloat = () => {
        var dFloat = 0;

        dFloat = this.bufferRcv.readFloat();

        return dFloat;
    };

    getDouble = () => {
        var dDouble = 0;

        dDouble = this.bufferRcv.readDouble();

        return dDouble;
    };

    getString = () => {
        var lengthStr = this.getShort();

        var dString = this.bufferRcv.readString(
            lengthStr,
            ByteBuffer.METRICS_CHARS
        );

        return dString;
    };

    dataSend = () => {
        this.bufferSnd.flip();
        return this.bufferSnd.toBuffer();
    };
}

export default Package;
